export default "__VITE_ASSET__DvrdQzDb__"